import {ApiBase} from '@ozark/common';
import {StatementData} from '@ozark/functions/src/functions/express/private/types';
import {ContextKey} from '@ozark/functions/src/functions/express/private/types/Context';
import {CancelToken} from 'axios';

export class StatementsApi extends ApiBase {
  getStatements = (year: number, mid: string, cancelToken?: CancelToken) => {
    const query = `${ContextKey.Year}=${year}`;
    return this.get<StatementData[]>(
      `statements?${query}`,
      {
        [ContextKey.Mid]: mid,
      },
      cancelToken
    );
  };
}
